<style lang="less">
  @import "./Demo.less";
</style>

<template>
  <div class="demo">
    <h1 @click="test">This is an {{text}} page</h1>
    <!--搜索-->
    <van-search style="padding: 10px;" placeholder="请输入搜索关键词" @search="onSearchFn" v-model="searchValue" />
  </div>
</template>

<script>
import Demo from './Demo.js'
export default {
  ...Demo
}
</script>
